import React from 'react'
import AddUserList from '../../features/coordinator/AddUserList'

const AddUserListPage = () => {
  return <AddUserList/>
}

export default AddUserListPage